import Reveal from "@stimulus-components/reveal"

export default class extends Reveal {
  static targets = ["buttonText", "showMoreIcon", "showLessIcon"]
  static values = { showText: String, hideText: String }

  toggle(event) {
    super.toggle(event)

    const hidden = this.itemTargets.every(el => el.classList.contains(this.hiddenClass))

    if (hidden) {
      this.buttonTextTarget.textContent = this.showTextValue
      this.showMoreIconTarget.classList.remove("hidden")
      this.showLessIconTarget.classList.add("hidden")
    } else {
      this.buttonTextTarget.textContent = this.hideTextValue
      this.showMoreIconTarget.classList.add("hidden")
      this.showLessIconTarget.classList.remove("hidden")
    }
  }
}